export default "__VITE_ASSET__OpwMPb1Y__"